/**
 * @desc 保存
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierOrganizationalUnitRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierOrganizationalUnit/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
